'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Record } from 'immutable';
import { fromNetwork } from 'AdsUI/records/ad-management/BudgetRecord';
import { fromMillis } from 'AdsUI/records/ad-management/ScheduleRecord';
import FBTargetingRecord from 'AdsUI/records/ad-management/FBTargetingRecord';
import FBPlacementRecord from '../ad-management/FBPlacementRecord';
const DEFAULTS = {
  id: null,
  name: null,
  network: null,
  status: null,
  effectiveStatus: null,
  accountId: null,
  campaignId: null,
  targeting: null,
  placement: null,
  previousState: null,
  budget: null,
  minBudget: null,
  maxBudget: null,
  schedule: null
};
export default class FBAdSetRecord extends Record(DEFAULTS) {
  constructor(props) {
    const {
      endTime,
      startTime,
      budget,
      minBudget,
      maxBudget,
      rawTargeting = '{}'
    } = props,
          data = _objectWithoutPropertiesLoose(props, ["endTime", "startTime", "budget", "minBudget", "maxBudget", "rawTargeting"]);

    const parsedRawTargeting = rawTargeting && JSON.parse(rawTargeting);
    super(Object.assign({}, data, {
      budget: budget && fromNetwork(budget),
      minBudget: minBudget && fromNetwork(minBudget),
      maxBudget: maxBudget && fromNetwork(maxBudget),
      schedule: fromMillis(startTime, endTime),
      targeting: parsedRawTargeting && FBTargetingRecord.fromTargeting(parsedRawTargeting),
      placement: parsedRawTargeting && FBPlacementRecord.fromRawTargeting(parsedRawTargeting)
    }));
  }

}